var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { getType } from "typesafe-actions";
import * as customization from "./actions";
export var initialState = {
  showPointsInfo: true
};
export var customizationReducer = function customizationReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(customization.modify_show_points_info):
      return __assign({}, state, {
        showPointsInfo: action.payload
      });

    default:
      return state;
  }
};